export default "__VITE_ASSET__5SI6uX1f__"